module.exports = __webpack_public_path__ + "static/media/proTip1.708835dc.svg";